export default __webpack_public_path__ + "static/marbel-alt-8e46f7a76b91c3224144fdce95174a0c.jpg";